import universal from 'react-universal-component';

export default universal(() => import('./Create'));



// WEBPACK FOOTER //
// ./src/app/views/Custom/Create/index.js